export default __webpack_public_path__ + "static/media/new-application-icon.aa011d30.svg";